import React from "react"
import WOW from "react-wow"
import { Container, Row, Col } from "@bootstrap-styled/v4"
import { StaticQuery, graphql } from "gatsby"

import * as S from "./styled"

const DepoimentosClientes = () => (
  <StaticQuery
    query={graphql`
      query {
        content: allMarkdownRemark(
          filter: { fileAbsolutePath: { regex: "/(clients)/.*.md$/" } }
        ) {
          edges {
            node {
              frontmatter {
                title
                description
                website
                show
                image {
                  childImageSharp {
                    fluid(maxWidth: 200) {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => (
      <S.DepoimentosClientesWrapper>
        <Container>
          <S.DepoimentosClientesHeader>
            <S.DepoimentosClientesSubTitle>
              Alguns ilustres clientes que
            </S.DepoimentosClientesSubTitle>
            <S.DepoimentosClientesTitle>
              Já evoluiram
            </S.DepoimentosClientesTitle>
            <S.DepoimentosClientesSubTitle style={{ marginTop: "-13px" }}>
              seus projetos com a Evolve
            </S.DepoimentosClientesSubTitle>
          </S.DepoimentosClientesHeader>

          <S.DepoimentosClientesList>
            <Row style={{ justifyContent: "center" }}>
              {data.content.edges
                .filter(cliente => cliente.node.frontmatter.show)
                .map((cliente, i) => (
                  <WOW animation="fadeIn" key={i}>
                    <Col xs={4} md={3}>
                      <S.DepoimentosClientesItem
                        href={cliente.node.frontmatter.website}
                        target="_blank"
                      >
                        <S.DepoimentosClientesItemImage
                          alt={"Logo " + cliente.node.frontmatter.title}
                          title={cliente.node.frontmatter.title}
                          fluid={
                            cliente.node.frontmatter.image.childImageSharp.fluid
                          }
                        />
                      </S.DepoimentosClientesItem>
                    </Col>
                  </WOW>
                ))}
            </Row>
          </S.DepoimentosClientesList>
        </Container>
      </S.DepoimentosClientesWrapper>
    )}
  />
)

export default DepoimentosClientes
